/*
 * @Author: zhaihaooran
 * @Date: 2021-07-13 21:41:33
 * @LastEditors: OBKoro1
 * @FilePath: /umu_mobile/src/businessCommon/hooks/useBoolean.ts
 */
import { useMemo } from 'react';
import { useToggle } from './useToggle';

export interface IActions {
    setTrue: () => void;
    setFalse: () => void;
    toggle: (value?: boolean | undefined) => void;
}

export function useBoolean(defaultValue = false): [boolean, IActions] {
    const [state, { toggle }] = useToggle(defaultValue);

    const actions: IActions = useMemo(() => {
        const setTrue = () => toggle(true);
        const setFalse = () => toggle(false);
        return { toggle, setTrue, setFalse };
    }, [toggle]);

    return [state, actions];
}
